import { OrganizeDetails } from '../organize-pdf';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { AjaxHandler } from '../../index';
import { enableDisableToolbarItems } from './organize-toolbar';
import { disableTileCopyRotateButton, disableTileDeleteButton } from './tile-interaction';
import { getNextSubIndex } from './organize-math-utils';
import { updatePageNumber, updateTotalPageCount } from './organize-initialization';
import { clonedCollection } from './organize-undoredoutils';
/**
 * @private
 * @param { any } args - It's describe about the imported document data.
 * @returns { void }
 */
export function importDocument(args) {
    if (this.pdfViewer.pageOrganizerSettings.canImport) {
        // eslint-disable-next-line
        var proxy_1 = this;
        var upoadedFiles = args.target.files;
        if (args.target.files[0] !== null) {
            var uploadedFile = upoadedFiles[0];
            if (uploadedFile) {
                this.importedDocumentName = uploadedFile.name;
                var reader = new FileReader();
                reader.readAsDataURL(uploadedFile);
                reader.onload = function (e) {
                    var uploadedFileUrl = e.currentTarget.result;
                    proxy_1.loadImportDoc(uploadedFileUrl, null, false);
                    if (!isNullOrUndefined(proxy_1.importDocInputElement)) {
                        proxy_1.importDocInputElement.value = '';
                    }
                };
            }
        }
    }
}
/**
 * @private
 * @param { string } documentData - It's describe about imported document base 64 or byte array data.
 * @param { string } password - It's describe about the imported document password.
 * @param { boolean } isPasswordCorrect - It's describe about the imported document password correct or not.
 * @returns { void }
 */
export function loadImportDoc(documentData, password, isPasswordCorrect) {
    var _this = this;
    if (this.pdfViewer.pageOrganizerSettings.canImport) {
        var proxy_2 = null;
        // eslint-disable-next-line
        proxy_2 = this;
        var isEncrypted_1 = false;
        this.importedDocumentData = documentData;
        var documentId_1 = this.pdfViewerBase.createGUID();
        var isbase64 = documentData.includes('pdf;base64,');
        var base64DocumentData = documentData;
        documentData = this.pdfViewerBase.checkDocumentData(documentData, false);
        var jsonObject_1 = this.pdfViewerBase.constructJsonObject(documentData, password, isbase64);
        if (this.pdfViewer.serverActionSettings) {
            this.pdfViewerBase.loadRequestHandler = new AjaxHandler(this.pdfViewer);
            this.pdfViewerBase.loadRequestHandler.url = this.pdfViewer.serviceUrl + '/' + this.pdfViewer.serverActionSettings.validatePassword;
            this.pdfViewerBase.loadRequestHandler.responseType = 'json';
            this.pdfViewerBase.loadRequestHandler.mode = true;
            jsonObject_1['action'] = 'ValidatePassword';
            jsonObject_1['elementId'] = this.pdfViewer.element.id;
            jsonObject_1['isFileName'] = 'false';
            if (this.pdfViewerBase.clientSideRendering) {
                this.pdfViewerBase.getPdfByteArray(base64DocumentData).then(function (pdfbytearray) {
                    var data = _this.pdfViewer.pdfRendererModule.loadImportDocument(pdfbytearray, documentId_1, password, jsonObject_1);
                    if (data) {
                        if (typeof data !== 'object') {
                            try {
                                data = JSON.parse(data);
                            }
                            catch (error) {
                                _this.pdfViewerBase.onControlError(500, data, _this.pdfViewer.serverActionSettings.load);
                                data = null;
                            }
                        }
                        if (data) {
                            while (typeof data !== 'object') {
                                data = JSON.parse(data);
                                if (typeof parseInt(data, 10) === 'number' && !isNaN(parseInt(data, 10))) {
                                    data = parseInt(data, 10);
                                    break;
                                }
                            }
                            if (data.uniqueId === documentId_1 || (typeof parseInt(data, 10) === 'number' && !isNaN(parseInt(data, 10)))) {
                                if (data === 4) {
                                    // 4 is error code for encrypted document.
                                    _this.pdfViewerBase.isImportDoc = true;
                                    isEncrypted_1 = true;
                                    _this.pdfViewerBase.renderPasswordPopup(documentData, password, _this.pdfViewerBase.isImportDoc);
                                }
                                else if (data === 3) {
                                    // 3 is error code for corrupted document.
                                    _this.pdfViewerBase.isImportDoc = true;
                                    _this.pdfViewerBase.renderCorruptPopup(_this.pdfViewerBase.isImportDoc);
                                }
                            }
                        }
                        if (isPasswordCorrect && data !== 4) {
                            _this.pdfViewerBase.passwordDialogReset();
                            if (_this.pdfViewerBase.passwordPopup) {
                                _this.pdfViewerBase.passwordPopup.hide();
                            }
                        }
                        if ((!isEncrypted_1 || (isPasswordCorrect && data !== 4)) && (data !== 3)) {
                            _this.importDocuments(password, _this.importedDocumentName, documentData);
                        }
                    }
                });
            }
            else {
                this.pdfViewerBase.loadRequestHandler.send(jsonObject_1);
                this.pdfViewerBase.loadRequestHandler.onSuccess = function (result) {
                    var data = result.data;
                    if (data) {
                        if (typeof data !== 'object') {
                            try {
                                data = JSON.parse(data);
                            }
                            catch (error) {
                                proxy_2.pdfViewerBase.onControlError(500, data, proxy_2.pdfViewer.serverActionSettings.load);
                                data = null;
                            }
                        }
                        if (data) {
                            while (typeof data !== 'object') {
                                data = JSON.parse(data);
                                if (typeof parseInt(data, 10) === 'number' && !isNaN(parseInt(data, 10))) {
                                    data = parseInt(data, 10);
                                    break;
                                }
                            }
                            if (data.uniqueId === documentId_1 || (typeof parseInt(data, 10) === 'number' && !isNaN(parseInt(data, 10)))) {
                                if (data === 4) {
                                    // 4 is error code for encrypted document.
                                    proxy_2.pdfViewerBase.isImportDoc = true;
                                    isEncrypted_1 = true;
                                    proxy_2.pdfViewerBase.renderPasswordPopup(documentData, password, proxy_2.pdfViewerBase.isImportDoc);
                                }
                                else if (data === 3) {
                                    // 3 is error code for corrupted document.
                                    proxy_2.pdfViewerBase.isImportDoc = true;
                                    proxy_2.pdfViewerBase.renderCorruptPopup(proxy_2.pdfViewerBase.isImportDoc);
                                }
                            }
                        }
                        if (isPasswordCorrect && data !== 4) {
                            proxy_2.pdfViewerBase.passwordDialogReset();
                            if (proxy_2.pdfViewerBase.passwordPopup) {
                                proxy_2.pdfViewerBase.passwordPopup.hide();
                            }
                        }
                        if ((!isEncrypted_1 || (isPasswordCorrect && data !== 4)) && (data !== 3)) {
                            proxy_2.importDocuments(password, proxy_2.importedDocumentName, documentData);
                        }
                    }
                };
            }
        }
    }
}
/**
 * @private
 * @param { string } password - It's describe about the imported document password.
 * @param { string } documentName - It's describe about the imported document name.
 * @param { string } documentData - It's describe about imported document base 64 or byte array data.
 * @returns { void }
 */
export function importDocuments(password, documentName, documentData) {
    if (this.pdfViewer.pageOrganizerSettings.canImport) {
        // eslint-disable-next-line
        var proxy = this;
        if (this.tileAreaDiv.querySelectorAll('.e-pv-organize-node-selection-ring').length === 1) {
            var _loop_1 = function (i) {
                var mainTileElement = proxy.tileAreaDiv.childNodes[parseInt(i.toString(), 10)];
                if (mainTileElement instanceof HTMLElement && mainTileElement.classList.contains('e-pv-organize-node-selection-ring')) {
                    var pageId = mainTileElement.id.split('anchor_page_')[mainTileElement.id.split('anchor_page_').length - 1];
                    var pageOrder_1 = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
                    var pageIdlist = pageId.split('_');
                    var subIndex = 0;
                    var pageIndex = parseInt(pageIdlist[parseInt((pageIdlist.length - 1).toString(), 10)], 10);
                    if (pageIdlist.length > 1) {
                        pageIndex = parseInt(pageIdlist[parseInt((pageIdlist.length - 2).toString(), 10)], 10);
                    }
                    subIndex = getNextSubIndex.call(this_1, mainTileElement.parentElement, pageIndex);
                    importPage.call(this_1, pageOrder_1, mainTileElement, password, documentName, false, documentData);
                    this_1.tileImageRender(pageIndex, subIndex, pageOrder_1 + 1, mainTileElement, true, false, false, true, documentName);
                    var clonedCollections = [];
                    clonedCollections.push(clonedCollection.call(this_1, this_1.tempOrganizePagesCollection.
                        find(function (item) { return item.currentPageIndex === (pageOrder_1 + 1); })));
                    this_1.addOrganizeAction(clonedCollections, 'Import Pages', [], [], null, false);
                }
            };
            var this_1 = this;
            for (var i = 0; i < proxy.tileAreaDiv.childElementCount; i++) {
                _loop_1(i);
            }
        }
        else {
            var mainTileElement = proxy.tileAreaDiv.childNodes[0];
            var pageId = mainTileElement.id.split('anchor_page_')[mainTileElement.id.split('anchor_page_').length - 1];
            var pageOrder_2 = parseInt(mainTileElement.getAttribute('data-page-order'), 10);
            var pageIdlist = pageId.split('_');
            var subIndex = 0;
            var pageIndex = parseInt(pageIdlist[parseInt((pageIdlist.length - 1).toString(), 10)], 10);
            if (pageIdlist.length > 1) {
                pageIndex = parseInt(pageIdlist[parseInt((pageIdlist.length - 2).toString(), 10)], 10);
            }
            subIndex = getNextSubIndex.call(this, mainTileElement.parentElement, pageIndex);
            importPage.call(this, pageOrder_2, mainTileElement, password, documentName, true, documentData);
            this.tileImageRender(pageIndex, subIndex, pageOrder_2, mainTileElement, true, true, false, true, documentName);
            var clonedCollections = [];
            clonedCollections.push(clonedCollection.call(this, this.tempOrganizePagesCollection.
                find(function (item) { return item.currentPageIndex === pageOrder_2; })));
            this.addOrganizeAction(clonedCollections, 'Import Pages', [], [], null, false);
        }
        updatePageNumber.call(this);
        updateTotalPageCount.call(this);
        enableDisableToolbarItems.call(this);
        disableTileCopyRotateButton.call(this);
        disableTileDeleteButton.call(this);
    }
}
/**
 * @private
 * @param { number } currentPageIndex - Its describe about the current page index.
 * @param { HTMLElement } tileDiv - It's describe about the import document tile place.
 * @param { string } password - It's describe about the imported document password.
 * @param { string } documentName - It's describe about the imported document name.
 * @param { boolean } isBefore - It's describe about the import position before or not.
 * @param { string } documentData - It's describe about imported document base 64 or byte array data.
 * @returns { void }
 */
export function importPage(currentPageIndex, tileDiv, password, documentName, isBefore, documentData) {
    if (this.pdfViewer.pageOrganizerSettings.canImport) {
        var index_1 = this.tempOrganizePagesCollection.findIndex(function (item) {
            return item.currentPageIndex === currentPageIndex;
        });
        var pageIndex = void 0;
        var pageSize = void 0;
        if (index_1 !== -1) {
            pageIndex = this.tempOrganizePagesCollection[parseInt(index_1.toString(), 10)].pageIndex;
            pageSize = JSON.parse(JSON.stringify(this.tempOrganizePagesCollection[parseInt(index_1.toString(), 10)].pageSize));
            if (isBefore) {
                this.tempOrganizePagesCollection = this.tempOrganizePagesCollection.slice(0, index_1).concat([new OrganizeDetails(currentPageIndex, -1, pageIndex, false, false, false, false, false, false, 0, pageSize, true, documentName, password, documentData)], this.tempOrganizePagesCollection.slice(index_1));
                this.tempOrganizePagesCollection = this.tempOrganizePagesCollection.map(function (item, mapIndex) {
                    if ((mapIndex !== index_1 && item.currentPageIndex >= currentPageIndex) && item.currentPageIndex != null) {
                        item.currentPageIndex = item.currentPageIndex + 1;
                    }
                    return item;
                });
                tileDiv.setAttribute('data-page-order', (currentPageIndex + 1).toString());
            }
            else {
                this.tempOrganizePagesCollection = this.tempOrganizePagesCollection.slice(0, index_1 + 1).
                    concat([new OrganizeDetails(currentPageIndex + 1, -1, pageIndex, false, false, false, false, false, false, 0, pageSize, true, documentName, password, documentData)], this.tempOrganizePagesCollection.slice(index_1 + 1));
                this.tempOrganizePagesCollection = this.tempOrganizePagesCollection.map(function (item, mapIndex) {
                    if (mapIndex > index_1 + 1 && item.currentPageIndex != null) {
                        item.currentPageIndex = item.currentPageIndex + 1;
                    }
                    return item;
                });
            }
            while (!isNullOrUndefined(tileDiv.nextElementSibling)) {
                var nextTileDiv = tileDiv.nextElementSibling;
                // eslint-disable-next-line @typescript-eslint/indent
                var nextTileIndex = parseInt(nextTileDiv.getAttribute('data-page-order'), 10);
                nextTileIndex = nextTileIndex + 1;
                nextTileDiv.setAttribute('data-page-order', nextTileIndex.toString());
                tileDiv = nextTileDiv;
            }
        }
    }
}
/**
 * @private
 * @returns { void }
 */
export function bindImportDocEvent() {
    if (this.pdfViewer.pageOrganizerSettings.canImport) {
        var importDocElement = document.getElementById(this.pdfViewer.element.id + '_import_pages');
        if (importDocElement) {
            this.importDocInputElement.click();
        }
    }
}
